"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";
import { parseHtml } from "@/utils/common";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL || "";

interface BannerImageData {
  attributes?: {
    url?: string;
  };
}

interface BannerImage {
  data?: BannerImageData;
}

interface BannerBlock {
  title?: string;
  form_title?: string;
  banner_image?: BannerImage;
}

interface BannerProps {
  block?: BannerBlock;
}

const Banner: React.FC<BannerProps> = ({ block }) => {
  const backgroundImage = block?.banner_image?.data?.attributes?.url
    ? `${baseUrl}${block.banner_image.data.attributes.url}`
    : "/images/leadership/leaders-banner.png";

  return (
    <>
      <section>
        <div className="leader-banner bg-background-dark pt-[120px] lg:pt-[150px] pb-[56px] lg:pb-[80px] xl:pb-[100px] relative z-0">
          {/* Shapes */}
          <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
            <Image
              src="/images/banner-left-layer-mobile.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full md:hidden"
            />
            <Image
              src="/images/banner-left-layer-tablet.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full hidden md:block lg:hidden"
            />
            <Image
              src="/images/banner-left-layer-desktop.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full hidden lg:block"
            />
          </div>
          <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
            <Image
              src="/images/banner-right-layer-mobile.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full md:hidden"
            />
            <Image
              src="/images/banner-right-layer-tablet.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full hidden md:block lg:hidden"
            />
            <Image
              src="/images/banner-right-layer-desktop.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full hidden lg:block"
            />
          </div>

          {/* Content */}
          <div className="container">
            <span className="text-gray-300 font-regular mb-[32px] block text-center text-subtitle-4">
              <Link href="/about-us">About Us</Link> /{" "}
              <Link href="/our-leadership">
                <span>Leadership Team</span>
              </Link>
            </span>
            <div className="blog-heading mb-[32px]">
              <h1 className="text-center text-white font-[800] text-display uppercase mb-[12px]">
                {parseHtml(block?.title ?? "TRooTech <br /> Leadership Team")}
              </h1>
              <p className="max-w-[1000px] mx-auto text-gray-50 text-center font-regular text-subtitle-3">
                {block?.form_title ??
                  "Driving Innovation & Digital Transformation"}
              </p>
            </div>
            <div className="relative z-1">
              <div className="container">
                <Image
                  src={backgroundImage}
                  alt="blog detail image"
                  width={1230 * 2}
                  height={480 * 2}
                  className="object-cover w-full xl:h-[480px] h-auto"
                  quality={100}
                  sizes="100vw"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
